module.exports = __webpack_public_path__ + "img/img-141.c7f925f8.png";